import Comp from './category-widget.vue'
export default Comp
